import { getGlobalSelectionModeSelector } from "components/advertising/logic/sagaHelpers";
import { createError } from "core/exceptions";
import { assertArray, assertObject } from "core/validation";
import { cloneDeep, uniqBy } from "lodash";
import log from "loglevel";
import { call, fork, put, select, takeLatest } from "redux-saga/effects";
import AdvertisingService from "services/advertisingService";
import { advertiserAddedSuccess, advertiserFailedAdvRepited, filterUpAdv } from "../../common";
import {
    actions,
    advInLogicErrorSelector,
    advToLogReportSelector,
    advertisersIdsSelector,
    advertisersSelector,
    filmReleaseInLogicErrorSelector,
    filmReleasesLogReportSelector,
    showCommentSelector,
} from "./logReportActions";

import { actions as pdfActions } from "components/fileViewers/logic/pdfActions";
import { advertisingListSelector, advertisingSelectedINListSelector } from "core/dataConstants";
import envconfig from "../../../../envconfig";

export function* addAdvToReport({ payload }) {
    try {
        const advertisers = yield select(advertisersSelector);
        const toAdd = assertArray(payload) ? filterUpAdv(payload, advertisers) : [];
        let filmReleases = yield select(filmReleasesLogReportSelector);
        yield call(addToReport, filmReleases, toAdd, advertisers);
    } catch (e) {
        log.error(e);
    }
}

export function* addToReport(filmReleases, toAdd, advertisers) {
    try {
        let invalidFilmRelease = null;
        log.debug("adding adv to report", filmReleases, advertisers, toAdd);
        let _advertisers = [];
        let _filmReleases = [];
        if (assertArray(toAdd)) {
            _advertisers = uniqBy([...advertisers, ...toAdd], (a) => a.id);
            _filmReleases = uniqBy([...filmReleases, ...toAdd.map((adv) => adv.filmRelease)], (fR) => fR.id);
        }
        if (!assertObject(invalidFilmRelease) && assertArray(toAdd)) {
            yield call(addAdvertisers, _filmReleases, _advertisers, _advertisers.length, toAdd.length);
        } else {
            if (!assertArray(toAdd) && !assertObject(invalidFilmRelease)) {
                advertiserFailedAdvRepited();
            }
            yield put(
                actions.ON_ADD_ADV_TO_LOG_REPORT.failed({
                    logicError: {
                        invalidFilmRelease: cloneDeep(invalidFilmRelease),
                        advToAdd: cloneDeep(toAdd),
                        advExist: !assertArray(toAdd),
                    },
                })
            );
        }
    } catch (error) {
        log.error(error);
    }
}
export function* addAdvertisers(filmReleases, advertisers, advertisersCount, toAddCount) {
    try {
        const advertisementTypes = advertisers.map((a) => ({
            ...a.advertisementType,
            value: a.advertisementType.id,
            label: a.advertisementType.name,
        }));
        const payloadResponse = {
            filmReleases: cloneDeep(filmReleases),
            advertisers: cloneDeep(advertisers),
            advToReport: cloneDeep(advertisers),
            advertisersCount: advertisersCount,
            advertisementTypes: uniqBy(advertisementTypes, (e) => e.id),
        };

        yield put(actions.ON_ADD_ADV_TO_LOG_REPORT.success(payloadResponse));
        yield fork(advertiserAddedSuccess, toAddCount, "Log sheet report");
    } catch (error) {
        log.error(error);
    }
}

export function* onLoadAdvReport() {
    try {
        yield select(filmReleasesLogReportSelector);

        const advertisersIds = yield select(advertisersIdsSelector);
        const advertisersResponse = yield call(AdvertisingService.getByIds, advertisersIds.join(","));
        const advertisers = advertisersResponse.data;
        const filmReleases = uniqBy(
            advertisers.map((adv) => adv.filmRelease),
            (fR) => fR.id
        );

        yield put(
            actions.ON_LOAD_LOG_REPORT_VIEW.success({
                filmReleases,
                advertisers: cloneDeep(advertisers),
                advToReport: cloneDeep(advertisers),
            })
        );
    } catch (e) {
        log.error(e);
        yield put(actions.ON_LOAD_LOG_REPORT_VIEW.failed(null, createError(e)));
    }
}
export function* addGlobalLogReport() {
    try {
        const selectionMode = yield select(getGlobalSelectionModeSelector);
        let list = [];
        if (selectionMode === 1) {
            list = yield select(advertisingListSelector);
        } else if (selectionMode === -1) {
            list = yield select(advertisingSelectedINListSelector);
        }
        if (assertArray(list)) {
            const advertisers = yield select(advertisersSelector);
            const toAdd = assertArray(list) ? filterUpAdv(list, advertisers) : [];
            let filmReleases = yield select(filmReleasesLogReportSelector);
            yield call(addToReport, filmReleases, toAdd, advertisers);
            yield put(actions.ON_ADD_GLOBAL_LOG_REPORT.success());
        }
    } catch (e) {
        log.error(e);
        yield put(actions.ON_ADD_GLOBAL_LOG_REPORT.failed(null, createError(e)));
    }
}
export function* onResetReportWithAdv() {
    try {
        const advertisers = yield select(advInLogicErrorSelector);
        const filmRelease = yield select(filmReleaseInLogicErrorSelector);
        yield call(addAdvertisers, filmRelease, advertisers, advertisers.length, advertisers.length);
        yield put(actions.ON_CLEAR_LOG_REPORT_ERROR.call());
    } catch (e) {
        log.error(e);
    }
}

export function* generateReportUrl() {
    try {
        const adv = yield select(advToLogReportSelector);
        const advList = adv.map((a) => a.id).join(",");
        const advTypes = adv.map((a) => a.advertisementType.id).join(",");
        const releaseList = uniqBy(adv.map((ad) => ad.filmRelease.id)).join(",");
        let url = `${envconfig.api}/report/log-sheet?releaseList=${releaseList}&advList=${advList}&advTypeList=${advTypes}`;
        const comment = yield select(showCommentSelector);
        if (comment) {
            url += "&showComment=true";
        }
        yield put(
            pdfActions.ON_OPEN_PDF.call({
                url,
            })
        );
    } catch (e) {
        log.error(e);
    }
}

export default [
    takeLatest(actions.ON_ADD_ADV_TO_LOG_REPORT.sendType, addAdvToReport),
    takeLatest(actions.ON_LOAD_LOG_REPORT_VIEW.sendType, onLoadAdvReport),
    takeLatest(actions.ON_ADD_GLOBAL_LOG_REPORT.sendType, addGlobalLogReport),
    takeLatest(actions.ON_CLEAR_WITH_NEW_FILM_RELEASE_LOG.type, onResetReportWithAdv),
    takeLatest(actions.ON_GENERATE_LOG_PREVIEW_URL.type, generateReportUrl),
];
